import { formatCurrency, payoffDate, monthsToYears } from "@/lib/amortize";

// CSS flex-bar chart of combined balance over time, with labelled endpoints.
export const BalanceChart = ({ schedule }) => {
  if (!schedule || schedule.length < 2) return null;

  const start = schedule[0].balance || 1;
  const months = schedule[schedule.length - 1].month;

  let bars = schedule;
  if (schedule.length > 60) {
    const step = Math.ceil(schedule.length / 60);
    bars = schedule.filter((_, i) => i % step === 0);
    if (bars[bars.length - 1] !== schedule[schedule.length - 1]) {
      bars.push(schedule[schedule.length - 1]);
    }
  }

  return (
    <div data-testid="balance-chart">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs font-bold text-slate-500 uppercase tracking-widest">Balance over time</span>
        <span className="text-xs text-slate-400 font-medium">{monthsToYears(months)} to $0</span>
      </div>

      <div className="flex gap-2">
        {/* Y-axis: balance at the endpoints */}
        <div className="flex flex-col justify-between items-end h-44 text-xs text-slate-400 tabular-nums py-0.5 shrink-0">
          <span data-testid="chart-start-balance" className="font-semibold text-slate-500">{formatCurrency(start, 0)}</span>
          <span>$0</span>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-end h-44 gap-[2px] w-full overflow-hidden border-l border-b border-slate-200 pl-1 pb-px">
            {bars.map((p, i) => {
              const h = Math.max((p.balance / start) * 100, p.balance > 0 ? 2 : 0);
              return (
                <div
                  key={p.month}
                  className="flex-1 min-w-[2px] bg-[#6BBDD4] rounded-t-sm transition-all duration-500 hover:bg-[#4AAFC9]"
                  style={{ height: `${h}%` }}
                  title={`Month ${p.month}: ${formatCurrency(p.balance, 0)}`}
                />
              );
            })}
          </div>
          {/* X-axis: time at the endpoints */}
          <div className="flex justify-between mt-2 text-xs font-medium">
            <span className="text-slate-400">Today · Month 0</span>
            <span className="text-[#4AAFC9] font-semibold tabular-nums" data-testid="chart-payoff-label">Month {months} · {payoffDate(months)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
